import { Skeleton, Typography, useMediaQuery } from "@mui/material"
import theme from "@skistarab/mui-theme"

import { BodyContainer, Separator } from "./index"

const ITEMS_SKELETON = {
  width: 140,
  mobileHeight: 17.5,
  tabletHeight: 22.8,
} as const

type ItemsSectionProps = {
  items?: string | string[]
  itemsLoading: boolean
}

const ItemsSection = ({ items, itemsLoading }: ItemsSectionProps) => {
  const isTablet = useMediaQuery(theme.breakpoints.up("md"))

  const normalizeItemsArray = (items: string | string[]): string[] => {
    return Array.isArray(items) ? items : [items]
  }

  if (itemsLoading) {
    return (
      <BodyContainer>
        <Skeleton
          variant="text"
          width={ITEMS_SKELETON.width}
          height={
            isTablet ? ITEMS_SKELETON.tabletHeight : ITEMS_SKELETON.mobileHeight
          }
        />
      </BodyContainer>
    )
  }

  if (!items) {
    return <BodyContainer></BodyContainer>
  }

  const itemsArray = normalizeItemsArray(items)

  return (
    <BodyContainer>
      {itemsArray.map((item, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center" }}>
          <Typography variant={isTablet ? "body2" : "body3"}>{item}</Typography>
          {index < itemsArray.length - 1 && (
            <Separator variant={isTablet ? "body2" : "body3"}>|</Separator>
          )}
        </div>
      ))}
    </BodyContainer>
  )
}

export default ItemsSection
